<template>
  <order-back-tracking v-if="!!tracking" :items="tracking.items" :total="tracking.total" :requested-units="orderBack.units.requested" :completed-units="orderBack.units.completed"/>
  <order-back-customer-info v-if="!!orderBack && orderBack.end_customer" :order-back="orderBack" />
  <order-back-summary v-if="!!orderBack" :order-back="orderBack" />
</template>

<script>

  import OrderBackTracking from "./OrderBackTracking.vue";
  import OrderBackCustomerInfo from "./OrderBackCustormerInfo.vue";
  import OrderBackSummary from "./OrderBackSummary.vue";

  export default {
    name: "OrderFooter",
    components: {
      OrderBackTracking,
      OrderBackCustomerInfo,
      OrderBackSummary
    },
    props: {
      orderBack: {
        type: Object,
        default: null,
      },
    },  
    computed: {
      tracking(){
        return this.$store.state.ordersBackList.orderTracking.data;
      }
    },
    watch: {
      orderBack(val) {
        if(val){
          this.$store.commit("ordersBackList/getTracking", val._id);
        }
      }
    },
  };

</script>